export enum ScoringType {
  CHECK_IN = 'checkIn',
  LIKERT_ONE_QUESTION = 'likertOneQuestion',
  LIKERT_MULTIPLE_QUESTIONS = 'likertMultipleQuestions',
}
